import type { AssessmentType } from '../apiClient';
import { ASSESSMENT_LABELS } from '../assessment/routes';

/** Human label for an assessment type (reuses the free-journey labels). */
export function assessmentLabel(type: AssessmentType): string {
  return ASSESSMENT_LABELS[type];
}

/**
 * Whether a report of this type has workbooks.
 *
 * Work Fit has none — not in legacy and not here — while Bottleneck and
 * Perspective each carry a 7-day and a 30-day. The rule lived inline in
 * `ReportPage`, which was the only place that needed it until the dashboard
 * began linking workbooks too. A second copy would drift the first time a
 * fourth assessment type appears, and the failure it produces is a workbook
 * link that 404s for someone who has paid.
 */
export function hasWorkbooks(type: AssessmentType): boolean {
  return type !== 'work_fit';
}

/** Format an ISO completion timestamp for display; empty string when absent. */
export function formatCompletedAt(iso: string | null): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}
